/**
 * ------------------------------------------------------------------------------------------------------------
 * ARCHITECTURAL NOTE:
 * KHÔNG sử dụng file index.ts (Barrel) trong thư mục @core để tránh Circular Dependency (NG0200).
 * Luôn import trực tiếp từ file nguồn.
 * ------------------------------------------------------------------------------------------------------------
 */
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {IUserDataLogin} from "@core/authentication/auth.model";
import {STORAGE_KEY} from "@core/constants";
import {LocalStorageService} from "@core/services/storage.service";
import {castInt} from "@shared/utils";

/**
 * ---------------------------------------------------------------------------------------------------------
 * - File này sẽ quản lý thông tin của user
 * - Không xử lý dữ liệu call API trong service
 * ---------------------------------------------------------------------------------------------------------
 * @author admin
 * */

@Injectable({
  providedIn: 'any'
})
export class UserService {
  private _userData!: IUserDataLogin | undefined;
  isAdmin: boolean = false;

  constructor(
    private localStorage: LocalStorageService
  ) {
  }

  setUserData(userData: IUserDataLogin) {
    this._userData = userData;
    this.localStorage.set(STORAGE_KEY.userData, userData);
  }

  getUserData() {
    if (!this._userData) {
      this._userData = this.localStorage.get(STORAGE_KEY.userData);
    }
    return this._userData;
  }


  get getUserId(): number {
    if (!this._userData) return 0;

    return this._userData.id ? castInt(this._userData.id) : 0;
  }

  clearUserData(): void {
    this._userData = undefined;
    this.localStorage.clearLocalStorageByPrefix(STORAGE_KEY.userData);
    this.localStorage.clearLocalStorageByPrefix(STORAGE_KEY.profileUI);
    this.localStorage.clearLocalStorageByPrefix(STORAGE_KEY.usr);
  }

  /**
   * Lưu cấu hình hiển thị cột lên Server (Placeholder)
   */
  saveColumnsDisplay(payload: { columnsDisplay: any[], type: number }): Observable<any> {
    // TODO: Triển khai gọi API thực tế khi Backend sẵn sàng
    console.log('API saveColumnsDisplay:', payload);
    return of({code: 1, messages: ['Thành công']});
  }

  /**
   * Lấy cấu hình hiển thị cột từ Server (Placeholder)
   */
  getColumnsDisplay(type: number): Observable<any> {
    // TODO: Triển khai gọi API thực tế để lấy cấu hình từ Server
    return of({code: 1, data: []});
  }
}
